import React, { useState, useEffect } from 'react';
import axios from 'axios';

const emptyCardForm = { label: '', bank_name: '', last4: '', notes: '' };

const CompanyList = ({ onManage }) => {
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(false);
  const [newCompany, setNewCompany] = useState('');

  const [cards, setCards] = useState([]);
  const [cardsLoading, setCardsLoading] = useState(false);
  const [newCard, setNewCard] = useState(emptyCardForm);
  const [editingCardId, setEditingCardId] = useState(null);
  const [editCardForm, setEditCardForm] = useState(emptyCardForm);

  const authHeaders = { headers: { Authorization: `Bearer ${localStorage.getItem('admin_token')}` } };

  const fetchCompanies = async () => {
    try {
      setLoading(true);
      const res = await axios.get('/api/admin/companies', authHeaders);
      setCompanies(res.data);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const fetchCards = async () => {
    try {
      setCardsLoading(true);
      const res = await axios.get('/api/admin/company-payment-cards', authHeaders);
      setCards(res.data);
    } catch (error) {
      console.error(error);
    } finally {
      setCardsLoading(false);
    }
  };

  useEffect(() => {
    fetchCompanies();
    fetchCards();
  }, []);

  const handleAdd = async (e) => {
    e.preventDefault();
    if (!newCompany.trim()) return;
    try {
      const res = await axios.post('/api/admin/companies', { name: newCompany }, authHeaders);
      setCompanies([res.data, ...companies]);
      setNewCompany('');
    } catch (error) {
      console.error(error);
    }
  };

  const handleAddCard = async (e) => {
    e.preventDefault();
    if (!newCard.label.trim()) return;
    try {
      await axios.post('/api/admin/company-payment-cards', newCard, authHeaders);
      setNewCard(emptyCardForm);
      fetchCards();
    } catch (error) {
      alert('Hata: ' + (error.response?.data?.error || error.message));
    }
  };

  const startEditCard = (card) => {
    setEditingCardId(card.id);
    setEditCardForm({ label: card.label || '', bank_name: card.bank_name || '', last4: card.last4 || '', notes: card.notes || '', is_active: !!card.is_active });
  };

  const saveEditCard = async (id) => {
    try {
      await axios.put(`/api/admin/company-payment-cards/${id}`, editCardForm, authHeaders);
      setEditingCardId(null);
      fetchCards();
    } catch (error) {
      alert('Hata: ' + (error.response?.data?.error || error.message));
    }
  };

  const toggleCardActive = async (card) => {
    try {
      await axios.put(`/api/admin/company-payment-cards/${card.id}`, { label: card.label, bank_name: card.bank_name, last4: card.last4, notes: card.notes, is_active: !card.is_active }, authHeaders);
      fetchCards();
    } catch (error) {
      alert('Hata: ' + (error.response?.data?.error || error.message));
    }
  };

  const handleDeleteCard = async (id) => {
    if (!window.confirm('Bu kart/hesabı silmek istediğinize emin misiniz?')) return;
    try {
      await axios.delete(`/api/admin/company-payment-cards/${id}`, authHeaders);
      fetchCards();
    } catch (error) {
      alert('Hata: ' + (error.response?.data?.error || error.message));
    }
  };

  return (
    <div style={{ padding: '10px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
        <h2 style={{ fontSize: '20px', fontWeight: 700, margin: 0, color: '#E5E7EB' }}>🏢 Bağımsız Firma Yönetimi</h2>
      </div>

      <div className="company-list-grid" style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', gap: '24px' }}>
        {/* Sol Panel - Firma Ekleme */}
        <div style={{ background: 'rgba(17,17,24,0.7)', border: '1px solid rgba(255,255,255,0.06)', borderRadius: '16px', padding: '24px', height: 'fit-content' }}>
          <h3 style={{ fontSize: '15px', fontWeight: 600, color: '#fff', marginBottom: '16px', marginTop: 0 }}>Yeni Firma Oluştur</h3>
          <form onSubmit={handleAdd} className="form-group" style={{ marginBottom: 0 }}>
            <label style={{ color: '#9CA3AF', fontSize: '13px', marginBottom: '6px' }}>Firma Adı</label>
            <input 
              type="text" 
              value={newCompany} 
              onChange={(e) => setNewCompany(e.target.value)} 
              placeholder="Örn: ABC Ajansı" 
              style={{
                width: '100%',
                padding: '12px 16px',
                background: 'rgba(26,26,36,0.6)',
                border: '1px solid rgba(255,255,255,0.08)',
                borderRadius: '12px',
                color: '#fff',
                fontSize: '14px',
                outline: 'none',
                marginBottom: '16px',
                boxSizing: 'border-box'
              }}
            />
            <button type="submit" style={{
              width: '100%',
              padding: '12px',
              background: 'linear-gradient(135deg, #10b981, #059669)',
              color: '#fff',
              border: 'none',
              borderRadius: '12px',
              fontWeight: 600,
              cursor: 'pointer',
              transition: 'all 0.2s',
              boxShadow: '0 4px 12px rgba(16, 185, 129, 0.2)'
            }}>
              + Firmayı Ekle
            </button>
          </form>
        </div>

        {/* Sağ Panel - Firma Listesi */}
        <div style={{ background: 'rgba(17,17,24,0.7)', border: '1px solid rgba(255,255,255,0.06)', borderRadius: '16px', overflow: 'hidden' }}>
          <div style={{ padding: '20px 24px', borderBottom: '1px solid rgba(255,255,255,0.06)' }}>
            <h3 style={{ fontSize: '15px', fontWeight: 600, color: '#fff', margin: 0 }}>Kayıtlı Firmalar ({companies.length})</h3>
          </div>
          
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left' }}>
              <thead>
                <tr style={{ background: 'rgba(26,26,36,0.5)' }}>
                  <th style={{ padding: '14px 24px', color: '#9CA3AF', fontSize: '12px', fontWeight: 600, textTransform: 'uppercase' }}>Firma Adı</th>
                  <th style={{ padding: '14px 24px', color: '#9CA3AF', fontSize: '12px', fontWeight: 600, textTransform: 'uppercase' }}>Oluşturulma</th>
                  <th style={{ padding: '14px 24px', color: '#9CA3AF', fontSize: '12px', fontWeight: 600, textTransform: 'uppercase', textAlign: 'right' }}>İşlemler</th>
                </tr>
              </thead>
              <tbody>
                {companies.length === 0 ? (
                  <tr>
                    <td colSpan="3" style={{ padding: '40px 24px', textAlign: 'center', color: '#6B7280' }}>
                      <div style={{ fontSize: '32px', marginBottom: '12px' }}>🏢</div>
                      Henüz hiç firma eklenmemiş.
                    </td>
                  </tr>
                ) : (
                  companies.map(company => (
                    <tr key={company.id} style={{ borderBottom: '1px solid rgba(255,255,255,0.04)', transition: 'background 0.2s' }} onMouseEnter={e => e.currentTarget.style.background = 'rgba(255,255,255,0.02)'} onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                      <td style={{ padding: '16px 24px', color: '#E5E7EB', fontWeight: 500, fontSize: '14px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                          <div style={{ width: '32px', height: '32px', borderRadius: '8px', background: 'rgba(16, 185, 129, 0.15)', color: '#10b981', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 'bold' }}>
                            {company.name.charAt(0).toUpperCase()}
                          </div>
                          {company.name}
                        </div>
                      </td>
                      <td style={{ padding: '16px 24px', color: '#6B7280', fontSize: '13px' }}>
                        {new Date(company.created_at).toLocaleDateString('tr-TR')}
                      </td>
                      <td style={{ padding: '16px 24px', textAlign: 'right' }}>
                        <button 
                          onClick={() => onManage && onManage(company.id)} 
                          style={{
                            padding: '8px 16px',
                            background: 'rgba(59, 130, 246, 0.1)',
                            color: '#60A5FA',
                            border: '1px solid rgba(59, 130, 246, 0.2)',
                            borderRadius: '8px',
                            fontSize: '13px',
                            fontWeight: 500,
                            cursor: 'pointer',
                            transition: 'all 0.2s'
                          }}
                          onMouseEnter={e => { e.currentTarget.style.background = 'rgba(59, 130, 246, 0.2)'; e.currentTarget.style.borderColor = 'rgba(59, 130, 246, 0.4)'; }}
                          onMouseLeave={e => { e.currentTarget.style.background = 'rgba(59, 130, 246, 0.1)'; e.currentTarget.style.borderColor = 'rgba(59, 130, 246, 0.2)'; }}
                        >
                          Yönet ➔
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* Kartlar / Hesaplar - gider girilirken "hangi karttan ödendi" secimi icin */}
      <div style={{ marginTop: '24px', background: 'rgba(17,17,24,0.7)', border: '1px solid rgba(255,255,255,0.06)', borderRadius: '16px', overflow: 'hidden' }}>
        <div style={{ padding: '20px 24px', borderBottom: '1px solid rgba(255,255,255,0.06)' }}>
          <h3 style={{ fontSize: '15px', fontWeight: 600, color: '#fff', margin: 0 }}>💳 Kartlar / Hesaplar ({cards.length})</h3>
          <p style={{ margin: '6px 0 0', fontSize: '12px', color: '#6B7280' }}>Gider girerken hangi karttan/hesaptan ödendiğini seçebilmek için buradan kart/hesap ekleyin. Tüm firmalar için ortak kullanılır.</p>
        </div>

        <form onSubmit={handleAddCard} className="company-card-form" style={{ display: 'grid', gridTemplateColumns: '1.2fr 1fr 0.6fr 1.2fr auto', gap: '10px', padding: '16px 24px', borderBottom: '1px solid rgba(255,255,255,0.06)', alignItems: 'center' }}>
          <input required type="text" placeholder="Kart/Hesap Adı (örn: Şirket Kartı)" value={newCard.label} onChange={e => setNewCard({ ...newCard, label: e.target.value })} style={cardInputStyle} />
          <input type="text" placeholder="Banka" value={newCard.bank_name} onChange={e => setNewCard({ ...newCard, bank_name: e.target.value })} style={cardInputStyle} />
          <input type="text" maxLength={4} placeholder="Son 4 Hane" value={newCard.last4} onChange={e => setNewCard({ ...newCard, last4: e.target.value.replace(/\D/g, '') })} style={cardInputStyle} />
          <input type="text" placeholder="Not (opsiyonel)" value={newCard.notes} onChange={e => setNewCard({ ...newCard, notes: e.target.value })} style={cardInputStyle} />
          <button type="submit" style={{ padding: '10px 18px', background: 'linear-gradient(135deg, #10b981, #059669)', color: '#fff', border: 'none', borderRadius: '10px', fontWeight: 600, cursor: 'pointer', whiteSpace: 'nowrap' }}>
            + Ekle
          </button>
        </form>

        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left' }}>
            <thead>
              <tr style={{ background: 'rgba(26,26,36,0.5)' }}>
                <th style={{ padding: '12px 24px', color: '#9CA3AF', fontSize: '12px', fontWeight: 600, textTransform: 'uppercase' }}>Kart/Hesap</th>
                <th style={{ padding: '12px 24px', color: '#9CA3AF', fontSize: '12px', fontWeight: 600, textTransform: 'uppercase' }}>Banka</th>
                <th style={{ padding: '12px 24px', color: '#9CA3AF', fontSize: '12px', fontWeight: 600, textTransform: 'uppercase' }}>Son 4 Hane</th>
                <th style={{ padding: '12px 24px', color: '#9CA3AF', fontSize: '12px', fontWeight: 600, textTransform: 'uppercase' }}>Not</th>
                <th style={{ padding: '12px 24px', color: '#9CA3AF', fontSize: '12px', fontWeight: 600, textTransform: 'uppercase' }}>Durum</th>
                <th style={{ padding: '12px 24px', color: '#9CA3AF', fontSize: '12px', fontWeight: 600, textTransform: 'uppercase', textAlign: 'right' }}>İşlemler</th>
              </tr>
            </thead>
            <tbody>
              {cardsLoading ? (
                <tr><td colSpan="6" style={{ padding: '24px', textAlign: 'center', color: '#6B7280' }}>Yükleniyor...</td></tr>
              ) : cards.length === 0 ? (
                <tr><td colSpan="6" style={{ padding: '24px', textAlign: 'center', color: '#6B7280' }}>Henüz kart/hesap eklenmemiş.</td></tr>
              ) : (
                cards.map(card => (
                  <tr key={card.id} style={{ borderBottom: '1px solid rgba(255,255,255,0.04)' }}>
                    {editingCardId === card.id ? (
                      <>
                        <td style={{ padding: '10px 24px' }}><input type="text" value={editCardForm.label} onChange={e => setEditCardForm({ ...editCardForm, label: e.target.value })} style={cardInputStyle} /></td>
                        <td style={{ padding: '10px 24px' }}><input type="text" value={editCardForm.bank_name} onChange={e => setEditCardForm({ ...editCardForm, bank_name: e.target.value })} style={cardInputStyle} /></td>
                        <td style={{ padding: '10px 24px' }}><input type="text" maxLength={4} value={editCardForm.last4} onChange={e => setEditCardForm({ ...editCardForm, last4: e.target.value.replace(/\D/g, '') })} style={cardInputStyle} /></td>
                        <td style={{ padding: '10px 24px' }}><input type="text" value={editCardForm.notes} onChange={e => setEditCardForm({ ...editCardForm, notes: e.target.value })} style={cardInputStyle} /></td>
                        <td style={{ padding: '10px 24px', color: '#6B7280', fontSize: '13px' }}>{editCardForm.is_active ? 'Aktif' : 'Pasif'}</td>
                        <td style={{ padding: '10px 24px', textAlign: 'right', whiteSpace: 'nowrap' }}>
                          <button onClick={() => saveEditCard(card.id)} style={{ ...cardActionBtnStyle, background: 'rgba(16,185,129,0.15)', color: '#34d399', marginRight: '6px' }}>Kaydet</button>
                          <button onClick={() => setEditingCardId(null)} style={{ ...cardActionBtnStyle, background: 'rgba(255,255,255,0.06)', color: '#9CA3AF' }}>İptal</button>
                        </td>
                      </>
                    ) : (
                      <>
                        <td style={{ padding: '14px 24px', color: '#E5E7EB', fontWeight: 500, fontSize: '14px' }}>💳 {card.label}</td>
                        <td style={{ padding: '14px 24px', color: '#9CA3AF', fontSize: '13px' }}>{card.bank_name || '-'}</td>
                        <td style={{ padding: '14px 24px', color: '#9CA3AF', fontSize: '13px' }}>{card.last4 ? `****${card.last4}` : '-'}</td>
                        <td style={{ padding: '14px 24px', color: '#6B7280', fontSize: '13px' }}>{card.notes || '-'}</td>
                        <td style={{ padding: '14px 24px' }}>
                          <span style={{ fontSize: '11px', fontWeight: 700, padding: '3px 10px', borderRadius: '6px', background: card.is_active ? 'rgba(16,185,129,0.12)' : 'rgba(107,114,128,0.15)', color: card.is_active ? '#34d399' : '#9CA3AF' }}>
                            {card.is_active ? 'Aktif' : 'Pasif'}
                          </span>
                        </td>
                        <td style={{ padding: '14px 24px', textAlign: 'right', whiteSpace: 'nowrap' }}>
                          <button onClick={() => startEditCard(card)} style={{ ...cardActionBtnStyle, background: 'rgba(59,130,246,0.1)', color: '#60A5FA', marginRight: '6px' }}>Düzenle</button>
                          <button onClick={() => toggleCardActive(card)} style={{ ...cardActionBtnStyle, background: 'rgba(245,158,11,0.1)', color: '#fbbf24', marginRight: '6px' }}>{card.is_active ? 'Pasif Yap' : 'Aktif Yap'}</button>
                          <button onClick={() => handleDeleteCard(card.id)} style={{ ...cardActionBtnStyle, background: 'rgba(239,68,68,0.1)', color: '#ef4444' }}>Sil</button>
                        </td>
                      </>
                    )}
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      <style>{`
        @media (max-width: 768px) {
          .company-list-grid { grid-template-columns: 1fr !important; }
          .company-card-form { grid-template-columns: 1fr !important; }
        }
      `}</style>
    </div>
  );
};

const cardInputStyle = { width: '100%', padding: '8px 12px', background: 'rgba(26,26,36,0.6)', border: '1px solid rgba(255,255,255,0.08)', borderRadius: '8px', color: '#fff', fontSize: '13px', outline: 'none', boxSizing: 'border-box' };
const cardActionBtnStyle = { padding: '6px 12px', border: 'none', borderRadius: '8px', fontSize: '12px', fontWeight: 500, cursor: 'pointer' };

export default CompanyList;
